module.exports = __webpack_public_path__ + "img/circle-5.a77d802.png";